/**
 * Created by Languagenut on 09/12/2019.
 */


import React from 'react';
import Base from '../wizards/assignments/activities_type.js';
import BootstrapTable from 'react-bootstrap-table-next';
import {Form , ProgressBar , Row , Col , Navbar  , Nav , NavDropdown} from 'react-bootstrap'
import Translation from '../../store/internationalization-store.js';
import LanguageSelect from '../language_select.js';
import AccountStore from '../../store/account-store.js';
import Constants from '../../constants.js';
import ContentSelection from  '../wizards/assignments/content.js';
import Wizard from '../wizards/wizard.js';
import SelectPrintable from '../wizards/printable-steps/select-printable.js'
import SelectContent from '../wizards/printable-steps/select-content.js';
import Save from '../wizards/printable-steps/save-printable.js';

export default class Printables extends Base.component {

    constructor(props) {
        super();
        this.props = {}
        this.props.data = {};
        this.state = {
            key:0
        }
    }

    set(){
        this.setLanguageValue.apply(this , arguments);
        this.setState({
            key:0
        })
    }

    render(){
        let steps = [SelectPrintable , SelectContent , Save];
        return <div>
            <Row>
                <Col md={6}>
                    <div class="d-flex align-items-left">
                        <div class="p-2 report_title">
                            {Translation.get(330 , 'Printable Resources')}
                        </div>
                    </div>
                </Col>
            </Row>
            <Row>
                <Col md={12}>
                    <Wizard stepsNavigation={true} steps={steps} />
                </Col>
            </Row>
        </div>;


    }
}
